import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from 'react-i18next';
import style from './home.module.css';

import logo from "../../images/logo.png"
import preview from "../../images/preview.png"

export default function Home() {
    const {t} = useTranslation();

    return (
        <section className={style.main}>
            <Helmet>
                <title>Talk - {t('home.title')}</title>
            </Helmet>

            <header className={style.header}>
                <a href="/" className={style.logo}><img src={logo} /></a>
                <ul className={style.ul}>
                    <li><a href="/" className={style.active}>{t('header.home')}</a></li>
                    <li><a href="#">{t('header.about_us')}</a></li>
                    <li><a href="//nkdtalk-support.web.app/">{t('header.support')}</a></li>
                </ul>
                <a href="#" className={style.app}><ion-icon name="arrow-down-outline" /> {t('header.get_app')}</a>
            </header>

            <div className={style.contentBx}>
                <div className={style.text}>
                    <h2>Talk</h2>
                    <p>{t('home.desc')}</p>
                    <h4>{t('home.download_the_app')}</h4>
                    <a href="#" className={style.btn}><ion-icon name="desktop-outline" /> Desktop</a>
                    <a href="#" className={style.btn}><ion-icon name="logo-android" /> Android</a>
                    <a href="#" className={style.btn}><ion-icon name="logo-apple" /> iOS</a>
                </div>

                <div className={style.imgBx}>
                    <img src={preview} className={style.imgPreview} />
                </div>

                <ul className={style.sci}>
                    <li><a href="//www.facebook.com/khanhduy1407" target="_blank"><ion-icon name="logo-facebook" /></a></li>
                    <li><a href="//www.instagram.com/dygameryt/" target="_blank"><ion-icon name="logo-instagram" /></a></li>
                    <li><a href="//github.com/talkapps" target="_blank"><ion-icon name="logo-github" /></a></li>
                </ul>
            </div>
        </section>
    )
}
